<template>
  <div>
    <div class="header">
      <div>
        <h1
         v-bind:class="{ '': isNormalLang, 'normal-lang': !isNormalLang }"
         v-html="translation.afiliate_program_ba"
         ></h1>
      </div>
      <div>
        <h3
         v-bind:class="{ '': isNormalLang, 'normal-lang': !isNormalLang }"
         v-html="translation.congratulations_info"></h3>
        <h4
         v-bind:class="{ '': isNormalLang, 'normal-lang': !isNormalLang }"
         v-html="translation.congratulations_info2"></h4>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "header-page",
  props: ["translation"],
  data() {
    return {
    langBr: this.$parent.$parent.view.lang,
    isNormalLang: true
    };
  },
  mounted() {
    //por ter problemas de codificacao de certos caracteres insere a font arial
    if(this.langBr == 'vi' ||
       this.langBr == 'si' ||
       this.langBr == 'ro' ||
       this.langBr == 'el' ||
       this.langBr == 'cn' ||
       this.langBr == 'ja' ||
       this.langBr == 'hi' ||
       this.langBr == 'bn' ||
       this.langBr == 'pa' ||
       this.langBr == 'th' ||
       this.langBr == 'ko'
      ) {
        this.isNormalLang = false;
      }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #2f006e;
  color: white;
  padding: 2rem 5rem;
  .normal-lang {
    font-family: arial;
  }
  h3 {
    font-weight: 300;
  }
}
@media (max-width: 900px) {
  .header {
    flex-direction: column;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/header.vue